import React from "react";
import { Typography } from "@mui/material";
import { RATING_SCALE_LEVELS } from "./ratingScale";

function RatingScaleGuide({ collapsible = false, open = true, onToggle }) {
  return (
    <div className="create-ranking-scale-guide-inner">
      <div className="create-ranking-scale-header">
        <Typography variant="subtitle2" component="h2" className="create-ranking-scale-title">
          Rating scale
        </Typography>
        {collapsible && (
          <button
            type="button"
            className="create-ranking-scale-toggle"
            onClick={onToggle}
            aria-expanded={open}
          >
            {open ? "Hide" : "Show"}
          </button>
        )}
      </div>
      {(!collapsible || open) && (
        <>
          <Typography variant="caption" className="create-ranking-scale-subtitle">
            Used when &ldquo;Include attributes&rdquo; is on. Enter whole numbers from 0 to 5.
          </Typography>
          <ol className="create-ranking-scale-list">
            {RATING_SCALE_LEVELS.map(({ value, label, description }) => (
              <li key={value} className="create-ranking-scale-item">
                <span className="create-ranking-scale-badge" aria-hidden>
                  {value}
                </span>
                <div className="create-ranking-scale-copy">
                  <Typography variant="body2" component="span" className="create-ranking-scale-label">
                    {label}
                  </Typography>
                  <Typography variant="caption" component="p" className="create-ranking-scale-desc">
                    {description}
                  </Typography>
                </div>
              </li>
            ))}
          </ol>
        </>
      )}
    </div>
  );
}

export default RatingScaleGuide;
